import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {
    pickDataFromQueryByAdditionalFields,
} from 'components/table/action/table-action.utils';
import {selectContextRawData} from 'modules/context/context-selector';
import {createActionGetFile} from 'modules/data/data-actions';
import {selectTableSelectedRowKeys} from 'modules/data/data-selectors';
import {useRequiredQueryParams} from 'shared/hooks/use-required-query-params';
import {ERequestType} from 'shared/types/requests';
import {useQueryParams} from 'shared/utils/query-params';
import {useAppSelector} from 'store/config/hooks';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../index';

export const ButtonDownloadSelectedRows: FC<ITableActionProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const {getQueryParam} = useQueryParams();
    const data = useAppSelector(selectContextRawData);
    const selectedRowKeys = useAppSelector(selectTableSelectedRowKeys(entityName)) || [];

    const {requiredQueryParams} = meta;
    const {isDisabled: areRequiredParamsMissing} = useRequiredQueryParams({requiredQueryParams});

    const handleClick = () => {
        const {requestType = ERequestType.GET, referenceUrl = entityName, additionalInfoKeys} = meta;
        let queryParamsData = {};
        if (requestType === ERequestType.POST) {
            dispatch(createActionGetFile({
                referenceUrl,
                requestType,
                data,
                body: {ids: selectedRowKeys || []},
            }));
            return;
        }
        if (additionalInfoKeys && requestType === ERequestType.GET) {
            const additionalData = pickDataFromQueryByAdditionalFields({additionalInfoKeys, getQueryParam});
            queryParamsData = {
                ...queryParamsData,
                ...(additionalData ?? {}),
            };
        }
        if (meta?.selectedReferenceUrl && !!selectedRowKeys.length) {
            const updatedUrl = `${meta?.selectedReferenceUrl}?${selectedRowKeys.map(ids => `ids=${ids}`).join('&')}`;
            dispatch(createActionGetFile({
                referenceUrl: updatedUrl,
                requestType,
                data: queryParamsData,
            }));
            return;
        }

        dispatch(createActionGetFile({
            referenceUrl,
            requestType,
            data: {...data, ...queryParamsData},
        }));
    };
    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={areRequiredParamsMissing || (!meta?.selectedReferenceUrl && !selectedRowKeys.length)}
        >
            {meta.actionTitle}
        </Component>
    );
};
